// extracted by mini-css-extract-plugin
export const mainVisual = "index-module--main-visual--11z0q";
export const list = "index-module--list--3jd4a";
export const line1 = "index-module--line1--LCmD8";
export const line2 = "index-module--line2--3Y_tw";
export const line3 = "index-module--line3--2bdgV";
export const movie = "index-module--movie--3SFoD";
export const play = "index-module--play--3DrOO";
export const more = "index-module--more--lYk6P";